<div class="api-main">
  <div class="api-flex-container">
    <div class="api-left-pannel">
      <mat-toolbar class="api-left-toolbar">
        <p class="left-panel-title">API Integrations</p>
        @if (isUserCanEdit && showNewApiBtn()) {
          <button class="new-api-btn" (click)="newApi()">
            New API
          </button>
        }
      </mat-toolbar>
      <div class="api-list">
        @if (isNewEndpoint === true && isNewApiButtonDisplayed) {
          <div
            class="api-list-item api-list-item-selected"
            >
            <img class="api-list-icon" src="../../../assets/svg/endpoint-w.svg" />
            <div class="api-list-name">[ New API ]</div>
          </div>
        }
        @if (apiListForDisplay | async; as list) {
          @if (list.length) {
            @for (api of list; track api) {
              <div
                class="api-list-item"
                (click)="apiSelect(api, api.name)"
                [ngClass]="{ 'api-list-item-selected': api.name === selectedApiName }"
                >
                <img
                  class="api-list-icon"
                  src="../../../assets/svg/redesign/close-tag.svg"
                  />
                  <div class="api-list-name">
                    {{ api.name }}
                    @if (api['isSandbox']) {
                      <mat-icon class="danger-icon">report_problem</mat-icon>
                    }
                  </div>
                </div>
              }
            } @else {
              <div class="setup-api-integrations">
                @if (bannerCmsData | async; as banner) {
                  <div class="notification-container">
                    <div class="notification-block">
                      <div class="icon">
                      </div>
                      <div class="content">
                        <div class="title">{{banner['title']}}
                        </div>
                        <a class="notification-description__link" target="_blank"
                          [href]= "banner['linkUrl']">
                          {{ banner['linkText'] }}
                        </a>
                      </div>
                    </div>
                  </div>
                } @else {
                  <loading-icon></loading-icon>
                }
                <p class="setup-api-integrations__message">You have no API integrations set up</p>
              </div>
            }
            @if (isUserCanEdit && isNewApiButtonDisplayed) {
              <button
                (click)="newApi()"
                class="api-list-integration-button"
                >
                <mat-icon class="api-list-integration-button__icon">add</mat-icon>
                <span>Add API Integration</span>
              </button>
            }
          } @else {
            <loading-icon></loading-icon>
          }
        </div>
      </div>
      @if (selectedApiName || isNewEndpoint) {
        <div class="api-right-pannel">
          <mat-tab-group
            [(selectedIndex)]="apiSelectedIndex"
            (selectedTabChange)="onTabChange($event)"
            animationDuration="300ms"
            disableRipple="true"
            class="clickatell-tabs api-content-tabs"
            >
            <mat-tab label="Edit">
              <ng-template mat-tab-label>Edit</ng-template>
              <div class="api-edit-container">
                <div class="api-edit-content">
                  <form id="api-form" class="api-form" [formGroup]="apiFormGroup">
                    @for (field of editFormFields; track field) {
                      <div [class]="field.cssClass + ' api-group'" [ngClass]="{'hide': !checkShowApiField(field.control), 'optional': field.optional}">
                        @if (checkShowApiField(field.control)) {
                          <div class="api-group-content">
                            <label [for]="field.id" class="api-group-label">{{ field.label }}</label>
                            <span class="api-group-label-tooltip">
                              @if (field.popover) {
                                <app-cms [cmsData]="buildCMSConditions('apiIntegration', field.control, null, field.popover.size)"></app-cms>
                              }
                            </span>
                            @if (field.type === 'input') {
                              <input
                                [id]="field.id"
                                [type]="field.fieldType"
                                class="api-group-input"
                        [ngClass]="{
                          'error-input':  (!apiFormGroup.controls[field.control].valid &&
                                    (apiFormGroup.controls['apiName'].dirty ||
                                    apiFormGroup.controls['apiName'].touched ||
                                    saveClicked))}"
                                [readonly]="!isUserCanEdit"
                                [formControlName]="field.control"
                                [placeholder]="field.placeholder"
                                />
                            }
                            @if (field.type === 'select') {
                              <div>
                                @if (isUserCanEdit) {
                                  <mat-select
                                    class="api-group-select"
                                    [formControlName]="field.control"
                                    [ngClass]="{'optional': field.optional}"
                                    (ngModelChange)="disableRequestTypeValidation()"
                                    [placeholder]="field.placeholder"
                                    hideSingleSelectionIndicator
                                    >
                                    @for (option of field.optionsList; track option) {
                                      <mat-option
                                        [id]="option.value ? option.value : option"
                                        [value]="option.value ? option.value : option"
                                        >
                                        {{ option.title ? option.title : option }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                }
                                @if (!isUserCanEdit) {
                                  <input
                                    [id]="field.id"
                                    [type]="field.fieldType"
                                    class="api-group-input"
                                    [ngClass]="{'optional': field.optional}"
                                    [readonly]="!isUserCanEdit"
                                    [formControlName]="field.control"
                                    [placeholder]="field.placeholder"
                                    />
                                }
                              </div>
                            }
                            @if (!apiFormGroup.controls[field.control].valid &&
                              (apiFormGroup.controls['apiName'].dirty ||
                              apiFormGroup.controls['apiName'].touched ||
                              saveClicked)) {
                              <div class='error-msg'>
                                {{ apiFormGroup.controls[field.control].errors.message }}
                              </div>
                            }
                          </div>
                        }
                      </div >
                    }
                    <ng-container formArrayName="headers">
                      <div class="api-test-bottom-header">
                        <table class="api-test-table">
                          <tr>
                            <td colspan="1">
                              <div class="api-header-test-label">
                                Headers
                                <span class="api-edit-optional">(Optional)</span>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th class="api-test-label">Key
                              <span class="api-label-tooltip">
                                <app-cms [cmsData]="buildCMSConditions('apiIntegration', 'key', null, 17)"></app-cms>
                              </span>
                            </th>
                            <th class="api-test-label" colspan="2">Value
                              <span class="api-label-tooltip">
                                <app-cms [cmsData]="buildCMSConditions('apiIntegration', 'value', null, 17)"></app-cms>
                              </span>
                            </th>
                          </tr>
                          @for (headersForm of apiFormGroup.get('headers').controls; track headersForm; let i = $index) {
                            <tr
                              class="api-key-value" [formGroup]="headersForm">
                              <td class="api-test-column">
                                <input  placeholder="Enter key..."
                                  type="text"
                                  class="api-group-input"
                                      [ngClass]="{
                                  'error-input':  checkInvalidHeaders(i, 'key', 'value')}"
                                  formControlName="key"
                                  [id]="'headerKey'+i"/>
                                  @if (checkInvalidHeaders(i, 'key', 'value')) {
                                    <div class="error-msg">
                                      <span class="fa fa-exclamation-circle"></span>
                                      Key {{this.apiFormGroup.get('headers')['controls'][i].controls['key'].errors.message}}
                                    </div>
                                  }
                                </td>
                                <td class="api-test-column">
                                  <input  placeholder="Enter value..."
                                    type="text"
                                    class="api-group-input"
                                    [ngClass]="{'error-input':  checkInvalidHeaders(i, 'value', 'key')}"
                                    formControlName="value"
                                    [id]="'headerValue'+i"/>
                                    @if (checkInvalidHeaders(i, 'value', 'key')) {
                                      <div class="error-msg">
                                        <span class="fa fa-exclamation-circle"></span>
                                        Value {{this.apiFormGroup.get('headers')['controls'][i].controls['value'].errors.message}}
                                      </div>
                                    }
                                  </td>
                                  <td class="api-test-delete-column">
                                    <span class="api-test-delete" (click)="removeHeader(i)"></span>
                                  </td>
                                </tr>
                              }
                              <tr>
                                <td colspan="3">
                                  <div class="api-new-key-value" (click)="addHeader()">
                                    Add New Key & Value
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </ng-container>
                        @if (isUserInternal && showRequestBody()) {
                          <div class="api-group optional">
                            <div class="api-group-content">
                              <label for="requestBody" class="api-group-label">
                                Request Body
                                <span class="api-edit-optional">(Optional)</span>
                              </label>
                              <textarea
                                id="requestBody"
                                rows="6"
                                class="api-group-input api-group-textarea"
                                [readonly]="!isUserCanEdit"
                                formControlName="requestBody"
                                placeholder="Enter a sample or template request body">
                              </textarea>
                            </div>
                          </div>
                        }
                        @if (isUserInternal) {
                          <div class="api-group optional">
                            <div class="api-group-content">
                              <label for="responseBody" class="api-group-label">
                                Response Body
                                <span class="api-edit-optional">(Optional)</span>
                              </label>
                              <textarea
                                id="responseBody"
                                rows="6"
                                class="api-group-input api-group-textarea"
                                [readonly]="!isUserCanEdit"
                                formControlName="responseBody"
                                placeholder="Enter a sample or template response body">
                              </textarea>
                            </div>
                          </div>
                        }
                      </form>
                    </div>
                    <div class="api-buttons-content">
                      @if (isUserCanEdit) {
                        <div>
                          <div class='buttons-block'>
                            <div class='left-btns-block'>
                              <button
                              [ngClass]="isDeleting ?
                          'toolbar-btn delete-toolbar-progress-btn' :
                          'toolbar-btn delete-toolbar-btn'"
                                (click)="deleteAPI()" [disabled]="isDeleting">
                                <div [ngStyle]="{display: isDeleting? 'inline-flex' : 'none'}" class="div-spin">
                                  <span class="span-spin1"></span>
                                  <span class="span-spin2"></span>
                                  <span class="span-spin3"></span>
                                </div>
                                {{isDeleting ? "Deleting" : "Delete"}}
                              </button>
                            </div>
                            <div class="right-btns-block">
                              <button
                              [ngClass]="isCancelling?
                          'toolbar-btn cancel-toolbar-progress-btn' :
                          'toolbar-btn cancel-toolbar-btn'"
                                (click)="cancel()" [disabled]="isCancelling">
                                <div [ngStyle]="{display: isCancelling ? 'inline-flex' : 'none'}" class="div-spin">
                                  <span class="span-spin1"></span>
                                  <span class="span-spin2"></span>
                                  <span class="span-spin3"></span>
                                </div>
                                {{isCancelling ? "Cancelling" : "Cancel"}}
                              </button>
                              <button
                              [ngClass]="isSaving ?
                          'toolbar-btn save-toolbar-progress-btn' :
                          'toolbar-btn save-toolbar-btn'"
                                (click)="checkIfAPIIsSandboxOnSave()" [disabled]="isSaving || !isFormDataValid">
                                <div [ngStyle]="{display: isSaving ? 'inline-flex' : 'none'}" class="div-spin">
                                  <span class="span-spin1"></span>
                                  <span class="span-spin2"></span>
                                  <span class="span-spin3"></span>
                                </div>
                                {{isSaving ? "Saving" : "Save"}}
                              </button>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </mat-tab>
                @if (isUserCanEdit) {
                  <mat-tab label="Test">
                    <ng-template mat-tab-label>Test</ng-template>
                    <div class="api-test-content">
                      <div class="api-test-top">
                        <div class="api-title">{{ apiFormGroup.get('apiName').value }}</div>
                        <div class="api-url">URL: <span>{{ selectedApiUrlDisplay }}</span></div>
                        <button
                [ngClass]="isTesting ?
                  'api-test-progress-button' : 
                  'api-test-button'"
                          (click)="testAPI()" [disabled]="isTesting">
                          <div [ngStyle]="{display: isTesting ? 'inline-flex' : 'none'}" class="div-spin">
                            <span class="span-spin1"></span>
                            <span class="span-spin2"></span>
                            <span class="span-spin3"></span>
                          </div>
                          {{isTesting ? "Loading Test" : "Test"}}
                        </button>
                        <!-- <button class="api-test-button" (click)="testAPI()">Test</button> -->
                        <div class="api-details">
                          <div class="api-details-section">
                            <p>Method: <span>{{ apiFormGroup.get('method').value }}</span></p>
                            @if (apiFormGroup.get('method').value != 'GET' && apiFormGroup.get('method').value != 'DELETE') {
                              <p>
                                Request Type: <span>{{ apiFormGroup.get('requestType').value }}</span>
                              </p>
                            }
                            <p>Response Type: <span>{{ apiFormGroup.get('responseType').value }}</span></p>
                            <p>Charset Type: <span>{{ apiFormGroup.get('charsetType').value }}</span></p>
                          </div>
                          <div class="api-details-section">
                            <p>Base Element: <span>{{ apiFormGroup.get('baseElement').value }}</span></p>
                            <p>Element Validation: <span>{{ apiFormGroup.get('elementValidation').value }}</span></p>
                          </div>
                        </div>
                      </div>
                      <div class="api-test-bottom">
                        <mat-tab-group
                          [(selectedIndex)]="testSelectedIndex"
                          animationDuration="300ms"
                          disableRipple="true"
                          class="clickatell-tabs"
                          >
                          @if (activeTab === 'Test') {
                            <mat-tab>
                              <ng-template mat-tab-label>Query Params</ng-template>
                              <div>
                                <div class="api-test-bottom-content">
                                  <table class="api-test-table">
                                    <tr>
                                      <th class="api-test-label">Key
                                        <app-cms [cmsData]="buildCMSConditions('apiIntegration', 'key', null, 24)"></app-cms>
                                      </th>
                                      <th class="api-test-label" colspan="2">Value
                                        <app-cms [cmsData]="buildCMSConditions('apiIntegration', 'value', null, 24)"></app-cms>
                                      </th>
                                    </tr>
                                    @for (param of getTestQueryParams(); track param; let i = $index; let isLast = $last) {
                                      <tr
                                        class="api-key-value"
                                        >
                                        <td class="api-test-column">
                                          <input
                                            #paramKey
                                            id="key{{ i }}QueryParams"
                                            type="text"
                                            class="api-group-input"
                                            value="{{ getObjectKeys(param) }}"
                                            (focusout)="onFocusOut(i, isLast, testQueryParams, 'QueryParams')"
                                            (input)="onChange($event, isLast, i, testQueryParams, 'QueryParams')"
                                            placeholder="Enter key..."
                                            />
                                            @if (paramValue.value.length > 0 && paramKey.value.length === 0) {
                                              <div class="error-msg">
                                                Is Required
                                              </div>
                                            }
                                          </td>
                                          <td class="api-test-column">
                                            <input
                                              #paramValue
                                              id="value{{ i }}QueryParams"
                                              type="text"
                                              class="api-group-input"
                                              value="{{ getObjectValue(param) }}"
                                              (focusout)="onFocusOut(i, isLast, testQueryParams, 'QueryParams')"
                                              (input)="onChange($event, isLast, i, testQueryParams, 'QueryParams')"
                                              placeholder="Enter value..."
                                              />
                                              @if (paramKey.value.length > 0 && paramValue.value.length === 0) {
                                                <div class="error-msg">
                                                  Is Required
                                                </div>
                                              }
                                            </td>
                                            <td class="api-test-delete-column">
                                              <span class="api-test-delete"
                                                (click)="removeParam(i, testQueryParams, 'QueryParams')">
                                              </span>
                                            </td>
                                          </tr>
                                        }
                                        <tr>
                                          <td colspan="3">
                                            <div class="api-new-key-value" (click)="addParamsKeyValue(testQueryParams)">
                                              Add New Key & Value
                                            </div>
                                          </td>
                                        </tr>
                                      </table>
                                    </div>
                                  </div>
                                </mat-tab>
                              }
                              <mat-tab>
                                <ng-template mat-tab-label>Headers</ng-template>
                                <div>
                                  <div class="api-test-bottom-content">
                                    <table class="api-test-table">
                                      <tr>
                                        <th class="api-test-label">
                                          Key
                                          <app-cms [cmsData]="buildCMSConditions('apiIntegration', 'key', null, '24')"></app-cms>
                                        </th>
                                        <th class="api-test-label" colspan="2">
                                          Value
                                          <app-cms [cmsData]="buildCMSConditions('apiIntegration', 'value', null, '24')"></app-cms>
                                        </th>
                                      </tr>
                                      @for (headersValue of apiFormGroup.get('headers').value; track headersValue) {
                                        <tr  class="api-key-value" >
                                          @if (headersValue.key && headersValue.value) {
                                            <td class="api-test-column">
                                              <input
                                                type="text"
                                                class="api-group-input"
                                                value="{{headersValue.key}}"
                                                disabled
                                                />
                                              </td>
                                            }
                                            @if (headersValue.key && headersValue.value) {
                                              <td class="api-test-column">
                                                <input
                                                  type="text"
                                                  class="api-group-input"
                                                  value="{{headersValue.value}}"
                                                  disabled
                                                  />
                                                </td>
                                              }
                                            </tr>
                                          }
                                          @for (param of testHeaders; track param; let i = $index; let isLast = $last) {
                                            <tr
                                              class="api-key-value"
                                              >
                                              <td class="api-test-column">
                                                <input
                                                  #paramKey
                                                  id="key{{ i }}Headers"
                                                  type="text"
                                                  class="api-group-input"
                                                  value="{{ getObjectKeys(param) }}"
                                                  (focusout)="onFocusOut(i, isLast, testHeaders, 'Headers')"
                                                  (input)="onChange($event, isLast, i, testHeaders, 'Headers')"
                                                  />
                                                  @if (paramValue.value.length > 0 && paramKey.value.length === 0) {
                                                    <div class="error-msg">
                                                      <span class="fa fa-exclamation-circle"></span>
                                                      Key is required
                                                    </div>
                                                  }
                                                </td>
                                                <td class="api-test-column">
                                                  <input
                                                    #paramValue
                                                    id="value{{ i }}Headers"
                                                    type="text"
                                                    class="api-group-input"
                                                    value="{{ getObjectValue(param) }}"
                                                    (focusout)="onFocusOut(i, isLast, testHeaders, 'Headers')"
                                                    (input)="onChange($event, isLast, i, testHeaders, 'Headers')"
                                                    required
                                                    />
                                                    @if (paramKey.value.length > 0 && paramValue.value.length === 0) {
                                                      <div class="error-msg">
                                                        <span class="fa fa-exclamation-circle"></span>
                                                        Value is required
                                                      </div>
                                                    }
                                                  </td>
                                                  <td class="api-test-delete-column">
                                                    <span class="api-test-delete"
                                                      (click)="removeParam(i, testHeaders, 'Headers')">
                                                    </span>
                                                  </td>
                                                </tr>
                                              }
                                              <tr>
                                                <td colspan="3">
                                                  <div class="api-new-key-value" (click)="addParamsKeyValue(testHeaders)">
                                                    Add New Key & Value
                                                  </div>
                                                </td>
                                              </tr>
                                            </table>
                                          </div>
                                        </div>
                                      </mat-tab>
                                      @if (
                                        apiFormGroup.get('method').value != 'GET' &&
                                        apiFormGroup.get('method').value != 'DELETE'
                                        ) {
                                        <mat-tab
                                          >
                                          <ng-template mat-tab-label>Body</ng-template>
                                          <div class="api-test-bottom-content">
                                            <div #bodyEditor data-type="monacoEditor" class="monaco-editor"></div>
                                          </div>
                                        </mat-tab>
                                      }
                                      @if (showResults) {
                                        <mat-tab>
                                          <ng-template mat-tab-label>Result Variables</ng-template>
                                          <div class="api-test-bottom-content">
                                            <div class="api-test-result-variables">
                                              <div class="api-test-result-variables-col-left-header">
                                                <b>API Integration Variable&nbsp;:&nbsp;</b>
                                              </div>
                                              <div class="api-test-result-variables-col-right-header">
                                                <b>Value</b>
                                              </div>
                                            </div>
                                            @for (variable of engineVariables | keyvalue; track variable) {
                                              <div
                                                class="api-test-result-variables"
                                                >
                                                <div class="api-test-result-variables-col-left">
                                                  {{ variable.key }}&nbsp;:&nbsp;
                                                </div>
                                                <div class="api-test-result-variables-col-right">
                                                  {{ variable.value }}
                                                </div>
                                              </div>
                                            }
                                          </div>
                                        </mat-tab>
                                      }
                                      @if (showResults) {
                                        <mat-tab label="Raw Results">
                                          <div [ngStyle]="{'display' : !isTesting ? 'flex' : 'none'}" class="api-test-bottom-content">
                                            <div #resultEditor data-type="monacoEditor" class="monaco-editor"></div>
                                          </div>
                                          <div [ngStyle]="{'display' : isTesting ? 'flex' : 'none'}">
                                            <div class="is-testing-container">
                                              @if (!isTimeOut) {
                                                <loading-icon></loading-icon>
                                              } @else {
                                                <div class="api-time-out-svg">
                                                  <svg
                                                    version="1.1"
                                                    id="icon"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    x="0px"
                                                    y="0px"
                                                    viewBox="0 0 108 92.6"
                                                    style="enable-background: new 0 0 108 92.6"
                                                    xml:space="preserve"
                                                    >
                                                    <title>icon</title>
                                                    <path
                                                      clip-path="url(#left)"
                                                      class="left-circle spinner"
                                                      d="M59,46c-0.1-4.7-1.7-9.4-4.8-13.3c-7.6-9.4-21.3-10.8-30.6-3.2S12.8,50.6,20.3,60S41.6,70.8,51,63.2"
                                                      />
                                                      <path
                                                        clip-path="url(#right)"
                                                        class="right-circle"
        d="M57.3,29.2c3.7-2.9,8.4-4.6,13.4-4.6c12,0,21.8,9.7,21.8,21.8s-9.7,21.8-21.8,21.8S49,58.3,49,46.3
      c0-1.7,0.2-3.3,0.5-4.8"
                                                        />
                                                        <clipPath id="left">
                                                          <path
                                                            class="st2"
          d="M44.8,61.8c-2.9,1.4-6.1,2-9.3,1.6c-4.6-0.5-8.7-2.7-11.6-6.3c-6-7.4-4.8-18.3,2.6-24.3
          c7.4-6,18.3-4.8,24.3,2.6c1.3,1.6,2.2,3.3,2.9,5.2l9.9,5.3l0,0c-0.1-5.9-2.1-11.5-5.8-16.1c-9.1-11.3-25.7-13-36.9-3.9
          C9.5,35,7.7,51.5,16.8,62.8c4.4,5.5,10.7,8.9,17.7,9.6c0.9,0.1,1.9,0.1,2.8,0.1c4.7,0,9.3-1.3,13.3-3.7
          C48.4,66.9,46.4,64.5,44.8,61.8z"
                                                            />
                                                          </clipPath>
                                                          <clipPath id="right">
                                                            <path
                                                              class="st2"
          d="M70.7,20c-4.8,0-9.3,1.3-13.4,3.7c2.3,2,4.3,4.4,5.8,7.1c2.3-1.1,4.9-1.7,7.5-1.7C80.3,29,88,36.8,88,46.3
          c0,9.5-7.7,17.3-17.3,17.3c-9.5,0-17.2-7.7-17.3-17.2l-8.6-4.6c-0.3,1.5-0.4,3-0.4,4.5c0,14.5,11.8,26.3,26.3,26.3S97,60.8,97,46.3
          S85.2,20,70.7,20z"
                                                              />
                                                            </clipPath>
                                                          </svg>
                                                        </div>
                                                      }
                                                      <div class="api-testing-duration">{{ testDurationCounter }}ms</div>
                                                    </div>
                                                  </div>
                                                </mat-tab>
                                              }
                                            </mat-tab-group>
                                          </div>
                                        </div>
                                      </mat-tab>
                                    }
                                  </mat-tab-group>
                                </div>
                              } @else {
                                <div class="api-right-pannel api-no-selection">
                                  Please select an API integration on the left or add a new API integration
                                </div>
                              }
                            </div>
                          </div>





                          <ng-template #saveAPIIntegration>
                            <div class="flow_save_new">
                              <div class="flow_save_new_title">
                                You're about to save an API integration created in the Sandbox.
                                Please check that the values are appropriate for production before continuing.
                              </div>
                              <div class="flow_save_new_buttonsContainer">
                                <button class="toolbar_saveBtn btnPrimary flow_save_new_button" (click)="returnToAPIIntegration()">
                                  Cancel
                                </button>

                                <button
                                  class="toolbar_saveBtn btnPrimary flow_save_new_button"
                                  (click)="saveAPI()"
                                  >
                                  Save
                                </button>
                              </div>
                            </div>
                          </ng-template>